<div class="content-builder-container">
  <!-- header -->
  <section class="content-builder-header">
    <div class="header-title-container">
      @if (creatingLesson) {
        <mat-icon
          svgIcon="lesson-math"
          class="header-icon"
        ></mat-icon>
      }
      <h3 class="header-title">
        {{ headerTitle }}
      </h3>
    </div>

    <div class="header-helper-container">
      <p class="header-helper-text">
        {{ helperText }}
      </p>
    </div>
  </section>

  <!-- main -->
  @if (creatingLesson) {
    <div class="content-builder-main create-lesson">
      @if (programsLoaded$ | async) {
        <lesson-builder-form
          [activePrograms]="activePrograms$ | async"
          [activeEditions]="activeEditions$ | async"
          [assetInUse]="assetInUse$ | async"
          [userGUID]="userGUID$ | async"
          [convertToLesson]="convertToLesson"
          [currentLessonForm]="lessonFormData"
          [subjectId]="subjectId"
          [editionId]="editionId"
          [selectedAssets]="selectedAssets"
          [lessonFormValidity]="lessonFormValidity"
          [editingLesson]="editingLesson"
          (setCurrentLessonForm)="onSetLessonFormData($event)"
          (setLessonFormData)="setLessonFormData($event)"
          (setLessonFormValidity)="setLessonFormValidity($event)"
        ></lesson-builder-form>
      }
    </div>
  }
  @if (creatingActivity) {
    <div class="content-builder-main create-activity">
      @if (programsLoaded$ | async) {
        <activity-builder
          [activePrograms]="activePrograms$ | async"
          [activeEditions]="activeEditions$ | async"
          [userGUID]="userGUID$ | async"
          [currentCustomActivityFormData]="customActivityFormData"
          [currentPerformActivityFormData]="performActivityFormData"
          [subjectId]="subjectId"
          [editionId]="editionId"
          [activityFormValidity]="activityFormValidity"
          [editingActivity]="editingActivity"
          [isDistributor]="isDistributor"
          (setCustomActivityFormData)="setCustomActivityFormData($event)"
          (setPerformActivityFormData)="setPerformActivityFormData($event)"
          (setActivityFormValidity)="setActivityFormValidity($event)"
          (clearActivityForm)="clearActivityForm()"
        ></activity-builder>
      }
    </div>
  }

  <!-- footer -->
  <div class="content-builder-footer">
    <!-- Cancel Panel -->
    <button
      type="button"
      color="primary"
      mat-raised-button
      class="cancel-button"
      (click)="closeBuilder()"
      >
      Cancel
    </button>

    <div class="activity-buttons">
      <!-- Create & Save -->
      @if (creatingActivity) {
        <button
          type="button"
          mat-raised-button
          color="primary"
          class="create-button"
          [disabled]="getCreateAddDisabled()"
          (click)="createActivity(true, false)"
          >
          @if (creatingActivity && editingActivity) {
            <span
              >Update & Save</span
              >
            }
            @if (creatingActivity && !editingActivity) {
              <span
                >Create & Save</span
                >
              }
            </button>
          }

          <!-- Create & Add -->
          @if (creatingActivity) {
            <button
              type="button"
              mat-raised-button
              class="create-add-button"
              [ngClass]="{ 'disabled-button': getCreateAddDisabled() }"
              [disabled]="getCreateAddDisabled()"
              (click)="createActivity(false, true)"
              >
              @if (creatingActivity && editingActivity) {
                <span
                  >Update & Add</span
                  >
                }
                @if (creatingActivity && !editingActivity) {
                  <span
                    >Create & Add</span
                    >
                  }
                  <mat-icon>add</mat-icon>
                </button>
              }
            </div>
          </div>
        </div>
